import { mockData } from "./Mock";
import { ChatMessageDTO } from "../../models/Chat";

const mockChatMessages: ChatMessageDTO[] = [
  {
    id: 1,
    seq_in_room: 1,
    roomId: 1001,
    senderId: "B001",
    buyerId: "B001",
    buyerPhone: "13800138001",
    buyerAvatarUrl: "https://via.placeholder.com/40x40",
    sellerId: "S001",
    sellerPhone: "13900139001",
    sellerAvatarUrl: "https://via.placeholder.com/40x40",
    content: "你好，我想了解一下这个商品",
    time: new Date("2024-03-15 10:00:00"),
    isWithdraw: false,
    isSystem: false,
    isCard: false,
    createTime: new Date("2024-03-15 10:00:00"),
    updateTime: new Date("2024-03-15 10:00:00")
  },
  {
    id: 2,
    seq_in_room: 2,
    roomId: 1001,
    senderId: "S001",
    buyerId: "B001",
    buyerPhone: "13800138001",
    buyerAvatarUrl: "https://via.placeholder.com/40x40",
    sellerId: "S001",
    sellerPhone: "13900139001",
    sellerAvatarUrl: "https://via.placeholder.com/40x40",
    content: JSON.stringify({
      type: 'product',
      productId: 'P001',
      specificationType: 'standard'
    }),
    time: new Date("2024-03-15 10:01:00"),
    isWithdraw: false,
    isSystem: false,
    isCard: true,
    createTime: new Date("2024-03-15 10:01:00"),
    updateTime: new Date("2024-03-15 10:01:00")
  },
  {
    id: 3,
    seq_in_room: 3,
    roomId: 1001,
    senderId: "B001",
    buyerId: "B001",
    buyerPhone: "13800138001",
    buyerAvatarUrl: "https://via.placeholder.com/40x40",
    sellerId: "S001",
    sellerPhone: "13900139001",
    sellerAvatarUrl: "https://via.placeholder.com/40x40",
    content: "这个商品有现货吗？",
    time: new Date("2024-03-15 10:02:00"),
    isWithdraw: false,
    isSystem: false,
    isCard: false,
    createTime: new Date("2024-03-15 10:02:00"),
    updateTime: new Date("2024-03-15 10:02:00")
  },
  {
    id: 4,
    seq_in_room: 4,
    roomId: 1001,
    senderId: "B001",
    buyerId: "B001",
    buyerPhone: "13800138001",
    buyerAvatarUrl: "https://via.placeholder.com/40x40",
    sellerId: "S001",
    sellerPhone: "13900139001",
    sellerAvatarUrl: "https://via.placeholder.com/40x40",
    content: JSON.stringify({
      type: 'image',
      url: 'https://via.placeholder.com/300x200',
      width: 300,
      height: 200
    }),
    time: new Date("2024-03-15 10:03:00"),
    isWithdraw: false,
    isSystem: false,
    isCard: true,
    createTime: new Date("2024-03-15 10:03:00"),
    updateTime: new Date("2024-03-15 10:03:00")
  },
  {
    id: 5,
    seq_in_room: 5,
    roomId: 1001,
    senderId: "S001",
    buyerId: "B001",
    buyerPhone: "13800138001",
    buyerAvatarUrl: "https://via.placeholder.com/40x40",
    sellerId: "S001",
    sellerPhone: "13900139001",
    sellerAvatarUrl: "https://via.placeholder.com/40x40",
    content: "有的，现在下单明天就能发货",
    time: new Date("2024-03-15 10:04:00"),
    isWithdraw: false,
    isSystem: false,
    isCard: false,
    createTime: new Date("2024-03-15 10:04:00"),
    updateTime: new Date("2024-03-15 10:04:00")
  }
];

const mockSellerMessages: ChatMessageDTO[] = [
  {
    id: 6,
    seq_in_room: 1,
    roomId: 1002,
    senderId: "S001",
    buyerId: "B002",
    buyerPhone: "13800138002",
    buyerAvatarUrl: "https://via.placeholder.com/40x40",
    sellerId: "S001",
    sellerPhone: "13900139001",
    sellerAvatarUrl: "https://via.placeholder.com/40x40",
    content: "欢迎光临，有什么可以帮您的吗？",
    time: new Date("2024-03-15 09:00:00"),
    isWithdraw: false,
    isSystem: false,
    isCard: false,
    createTime: new Date("2024-03-15 09:00:00"),
    updateTime: new Date("2024-03-15 09:00:00")
  },
  {
    id: 7,
    seq_in_room: 2,
    roomId: 1003,
    senderId: "S001",
    buyerId: "B003",
    buyerPhone: "13800138003",
    buyerAvatarUrl: "https://via.placeholder.com/40x40",
    sellerId: "S001",
    sellerPhone: "13900139001",
    sellerAvatarUrl: "https://via.placeholder.com/40x40",
    content: JSON.stringify({
      type: 'order',
      orderId: 'O001'
    }),
    time: new Date("2024-03-15 08:30:00"),
    isWithdraw: false,
    isSystem: false,
    isCard: true,
    createTime: new Date("2024-03-15 08:30:00"),
    updateTime: new Date("2024-03-15 08:30:00")
  }
];

const mockBuyerMessages: ChatMessageDTO[] = [
  {
    id: 8,
    seq_in_room: 1,
    roomId: 1004,
    senderId: "B001",
    buyerId: "B001",
    buyerPhone: "13800138001",
    buyerAvatarUrl: "https://via.placeholder.com/40x40",
    sellerId: "S002",
    sellerPhone: "13900139002",
    sellerAvatarUrl: "https://via.placeholder.com/40x40",
    content: "这个商品多少钱？",
    time: new Date("2024-03-15 11:00:00"),
    isWithdraw: false,
    isSystem: false,
    isCard: false,
    createTime: new Date("2024-03-15 11:00:00"),
    updateTime: new Date("2024-03-15 11:00:00")
  },
  {
    id: 9,
    seq_in_room: 2,
    roomId: 1004,
    senderId: "B001",
    buyerId: "B001",
    buyerPhone: "13800138001",
    buyerAvatarUrl: "https://via.placeholder.com/40x40",
    sellerId: "S002",
    sellerPhone: "13900139002",
    sellerAvatarUrl: "https://via.placeholder.com/40x40",
    content: JSON.stringify({
      type: 'quickContract',
      contractId: 'C001'
    }),
    time: new Date("2024-03-15 11:01:00"),
    isWithdraw: false,
    isSystem: false,
    isCard: true,
    createTime: new Date("2024-03-15 11:01:00"),
    updateTime: new Date("2024-03-15 11:01:00")
  }
];

mockData.set("room_messages", mockChatMessages);
mockData.set("seller_messages", mockSellerMessages);
mockData.set("buyer_messages", mockBuyerMessages); 